import { Container, Title } from './styles';
import { ICardMostUsedProps } from '../../models/ICardMostUsed';
import { useHistory } from 'react-router-dom';
import { MdOutlineLibraryBooks } from 'react-icons/md';
import { useLocalStorage } from 'react-use';
import { FiltersProps } from '../../@types';

const CardMostUsed: React.FC<ICardMostUsedProps> = ({ content, onCardClickTest, children}) => {
    const [,setLocalFilters] = useLocalStorage<FiltersProps>('filters', {})
    const history = useHistory();

    const handleClick = () => {
        onCardClickTest('')
        setLocalFilters({knowledge: [content.description]})
        history.push(`/disciplines/?q=&knowledge[]=${encodeURIComponent(content.description)}&page=1`);
    }

    return (
        <>
            <Container style={{ background: '#6473FF' }} data-testid="card"
                onClick={handleClick}>
                <Title>
                    
                    <h5 style={{ color: '#ffff'}}>{content.description}</h5>
                </Title>
                <div>
                    {!!content.icon_path ?
                        <img style={{ width: 62 + 'px', height: 'auto' }} src={content.icon_path} alt={content.description} /> :
                        <MdOutlineLibraryBooks size={62} color={'white'} />}
                </div>
            </Container>
        </>
    )

}

export default CardMostUsed